import { Flash, Box, Button, Text, Section } from '@acast/decibel';
import { Episode } from 'client/resources';
import React from 'react';
import { deleteEpisode } from 'resources/episode';
import Modal from 'shared/components/modal';
import resourceProp from 'shared/helpers/resource-prop';

const CONFIRM_DELETE_EPISODE = {
  title: 'Are you sure?',
  dialog:
    'Are you sure you want to delete this episode? Please note that this is a permanent operation.',
  actions: [
    { name: 'Cancel', value: false, variant: 'tertiary' },
    { name: 'Delete', value: true, variant: 'primary', intent: 'danger' },
  ],
};

class DeleteEpisode extends React.Component {
  static propTypes = {
    episode: resourceProp(Episode),
  };

  verifyDeleteEpisode = () => {
    Modal.bind(this, CONFIRM_DELETE_EPISODE).then(result => {
      if (result) {
        deleteEpisode(this.props.episode.data);
      }
    });
  };

  render() {
    const { episode } = this.props;

    return (
      <Section>
        <Text variant="h3">Delete Episode</Text>
        <Flash intent="danger">
          <strong>WARNING:</strong> By deleting this episode the file will be permanently removed
          from Create and become unavailable to your listeners. This action cannot be reversed.
        </Flash>
        <Box mt={4} justifyContent="flex-end">
          <Button
            disabled={episode.pending || episode.error}
            variant="primary"
            intent="danger"
            onClick={this.verifyDeleteEpisode}
          >
            Delete Episode
          </Button>
        </Box>
      </Section>
    );
  }
}

export default DeleteEpisode;
